import $ from 'jquery'
import {ElMessage} from 'element-plus'

export default {
    state: {
        id: "",
        userName: "",
        nickName: "",
        email: "",
        phone: "",
        gender: "",
        avatar: "",
        city: "",
        introduce: "",
        roles:[],
        is_login: false,
    },
    getters: {
    },
    mutations: {
        updateUser(state, user) {
            state.id = user.id;
            state.userName = user.userName;
            state.nickName = user.nickName;
            state.email = user.email;
            state.phone = user.phone;
            state.gender = user.gender;
            state.avatar = user.avatar;
            state.city = user.city;
            state.roles = user.roles;
            state.introduce = user.introduce;
            state.is_login = true;
        },
        logout(state) {
            state.id = "";
            state.userName = "";
            state.nickName = "";
            state.email = "";
            state.phone = "";
            state.gender = "";
            state.avatar = "";
            state.city = "";
            state.roles = [];
            state.introduce = "";
            state.is_login = false;
        },
        updatePullingInfo(state, pulling_info) {
            state.pulling_info = pulling_info;
        }
    },
    actions: {
        login(context, data) {
            $.ajax({
                url: "http://124.222.105.205:5000/visitor/api/user/login",
                type: "post",
                data: JSON.stringify({
                    userName: data.userName,
                    password: data.password
                }),
                headers: {
                    "Content-Type": "application/json"
                },
                success(resp) {
                    if (resp.code === "200") {
                        localStorage.setItem("token", resp.data.token);
                        context.commit("updateUser", resp.data);
                        data.success(resp.msg);
                    } else {
                        data.error(resp.msg);
                    }
                },
                error(resp) {
                    data.error(resp.msg);
                }
            });
        },
        getUserInfo(context, data) {
            $.ajax({
                url: "http://124.222.105.205:5000/api/user/getUserInfo/",
                type: "post",
                headers: {
                    Authorization: "Bearer " + data.token,
                },
                success(resp) {
                    console.log(resp);
                    if (resp.code === "200") {
                        context.commit("updateUser", resp.data);
                        data.success(resp);
                    } else {
                        localStorage.removeItem("token");
                        context.commit("logout");
                        data.error(resp);
                    }
                },
                error() {
                    ElMessage({
                        type: "error",
                        message: "请重新登录!",
                      });
                    localStorage.removeItem("token");
                    context.commit("logout");
                }
            });
        },
        logout(context, data) {
            const token = localStorage.getItem("token");
            localStorage.removeItem("token");

            $.ajax({
                url: "http://124.222.105.205:5000/api/user/logout/",
                type: "post",
                headers: {
                    Authorization: "Bearer " + token,
                },
                success(resp) {
                    context.commit("logout");
                    if (resp.code === "200") {
                        data.success();
                    } else {
                        data.error();
                    }
                },
                error() {
                    context.commit("logout");
                }
            });
            
        }
    },
    modules: {
    }
}
